// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"e4c68a1d","79":"619e5ccd","136":"8031cd92","220":"0f86c555","242":"826b8827","265":"a7dc1f4e","273":"95a422e4","349":"9e086bdf","445":"b66faf8c","446":"775276cc","530":"e45ab8b2","788":"e77b1bef"}[chunkId] + ".chunk.css";
};